<template lang="pug">
  .filters
    e-form.filters__form(
      :formValidator="formValidator"
    )
      e-form-group(
        name="report"
        :model="model"
        tabView="tab1"
        label="Отчетность"
        inputType="radio"
        :options="reports"
        @change="changeReports"
      )
      div
        div
          label.label.semibold Период
        e-form-group(
          inputType="calendar"
          formGroupStyle="filters__date-item"
          :model="model"
          tabView="tab1"
          type="date"
          name="issuance_date_start"
          placeholder='от дд.мм.гггг'
          toPlaceholder='до дд.мм.гггг'
          @changeCalendar='changeRange'
        )
        e-form-group(
          inputType="calendar"
          formGroupStyle="filters__date-item"
          :model="model"
          tabView="tab1"
          type="date"
          name="issuance_date_end"
          placeholder='до дд.мм.гггг'
          toPlaceholder='до дд.мм.гггг'
          @changeCalendar='changeRange'
        )
      search-msn(
        class-name='legend__type legend__type_with-small legend__type_search-msn'
        :isMsnTransportSearch="true"
        @updateSearch="searchMsn"
      )
</template>

<script>
import routeMixin from '@/mixins/route-mixin'
import formBaseMixin from '@/components/form/form-base-mixin'
import { msn } from '@/api/api-endpoints'
import SearchMsn from '../../routes/components/search-msn'

export default {
  name: 'filters',
  components: {
    SearchMsn,
  },
  mixins: [routeMixin, formBaseMixin],
  data() {
    return {
      model: {
        issuance_date_start: '',
        issuance_date_end: '',
        report: '',
        msns: '',
      },
      query: '',
    }
  },
  computed: {
    reports() {
      return [
        { id: 1, name: 'С отчетностью' },
        { id: 0, name: 'Без отчетности' },
        { id: null, name: 'Все' },
      ]
    },
  },
  methods: {
    getMsns() {
      this.$store.dispatch('updateUrlEndpoint', {
        endpoint: msn.addresses(),
        fromCache: true,
      })
    },
    async searchMsn(list) {
      const ids = list.map((item) => item.id)
      this.replaceRoute({
        msn_id: ids,
      })
      this.$emit('changeFilter')
    },
    changeRange() {
      this.replaceRoute({
        issuance_date_start: this.model.issuance_date_start,
        issuance_date_end: this.model.issuance_date_end,
      })
      this.$emit('changeFilter')
    },
    changeReports($event) {
      this.replaceRoute({
        has_report: $event.target.value,
      })
      this.$emit('changeFilter')
    },
  },
  created() {
    this.getMsns()
  },
}
</script>
<style lang="scss">
@import '../../../assets/scss/utils/variables';

.legend__type_search-msn {
  padding-top: 0;

  .legend {
    &__name {
      color: $grey-text-color;
    }
  }
}

.filters {
  &__date-item {
    margin-top: 5px;
  }
}
</style>
